import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const DropdownListWrapper = styled.div`
  padding: 8px 5px 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: scroll;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const DropdownListItem = styled.div<{ $isSelected: boolean }>`
  padding: 12px 8px 10px 8px;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryLight : COLORS.white};
  outline: ${({ $isSelected }) =>
    $isSelected && `1px solid ${COLORS.borderColor}`};
  &:hover {
    background: ${COLORS.primaryLight};
  }
  cursor: pointer;
  transition: all 0.3s;
`
